(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/components/customer-address-information.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/components/customer-address-information.js');
"use strict";


const {
  useCustomerPreferences
} = svs.ticketsOrderHome.hooks;
const {
  formatCustomerPreferenceAddressInfo,
  isCustomerPreferenceAddressInfoMissing
} = svs.ticketsOrderHome.utils;
const {
  Loader
} = svs.ticketsOrderHome.components;
const CustomerAddressInformationComponent = _ref => {
  let {
    className,
    loading,
    error,
    data,
    LoaderComponent = Loader
  } = _ref;
  if (loading) {
    return LoaderComponent ? React.createElement(LoaderComponent, null) : null;
  }
  if (error) {
    return React.createElement("div", {
      className: className
    }, React.createElement("p", {
      className: "f-content margin-bottom-0"
    }, "Adress kunde inte h\xE4mtas."));
  }
  if (isCustomerPreferenceAddressInfoMissing(data)) {
    return React.createElement("div", {
      className: className
    }, React.createElement("p", {
      className: "f-content margin-bottom-0"
    }, "Adress saknas."));
  }
  const {
    fullName,
    addressRow1,
    addressRow2,
    email,
    emailVerified
  } = formatCustomerPreferenceAddressInfo(data);
  return React.createElement("div", {
    className: "data-hj-suppress ".concat(className)
  }, React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, fullName), React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, addressRow1), React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, addressRow2), emailVerified && React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, email));
};
const CustomerAddressInformation = _ref2 => {
  let {
    className
  } = _ref2;
  const {
    data,
    error,
    loading
  } = useCustomerPreferences();
  return React.createElement(CustomerAddressInformationComponent, {
    className: className,
    data: data,
    error: error,
    loading: loading
  });
};
setGlobal('svs.ticketsOrderHome.orderHome.components.CustomerAddressInformationComponent', CustomerAddressInformationComponent);
setGlobal('svs.ticketsOrderHome.orderHome.components.CustomerAddressInformation', CustomerAddressInformation);

 })(window);